export default __webpack_public_path__ + "static/media/Member_GuanYuChen.a631ae36.jpg";